// export const FindIconWeNeed = (application, dif) => {
//     const existingCartItem = cartItems.find(cartItem => cartItem.id === cartItemToAdd.id);
//
//     if(existingCartItem) {
//         return cartItems.map(cartItem => cartItem.id === cartItemToAdd.id
//             ? {...cartItem , quantity: cartItem.quantity + 1}
//             : cartItem
//         )
//
//
//     }
//
//     return [...cartItems, { ...cartItemToAdd , quantity: 1}]
// }
// MOST MOVE TO CARS UTILS.JS


export const removeItemFromHoldOver = (holdOverCars, carToRemove) => {
    const existingCartItem = holdOverCars.find(cars => cars.id === carToRemove.id);
    return holdOverCars.filter(x => x.DeviceID !== existingCartItem.DeviceID)
};
export const addItemToHoldOver = (holdOverCars, carToAdd) => {
    const existingCartItem = holdOverCars.find(cars => cars.DeviceID === carToAdd.DeviceID);
    if (!existingCartItem){
        return [...holdOverCars, carToAdd]
    } else {
        return holdOverCars
    }
};
export const AttachLabel = (car) => {
    let newCar = [];
    car.map(item=>{
        item.label = item.Name;
        item.value = item.DeviceID;
        newCar.push(item)
    });
    return newCar
};